export default __webpack_public_path__ + "static/media/Mystery.5ebd37e6.jpg";